import { useState } from 'react';
import CompanyList from '@/components/companies/CompanyList';
import CompanyDetail from '@/components/companies/CompanyDetail';

export default function CompaniesPage() {
  const [selectedId, setSelectedId] = useState<string | null>(null);

  return (
    <div className="flex h-[calc(100vh-65px)]">
      <div className="w-80 border-r border-[var(--border)] overflow-y-auto">
        <CompanyList
          selectedId={selectedId}
          onSelect={setSelectedId}
        />
      </div>
      <div className="flex-1 overflow-y-auto">
        {selectedId ? (
          <CompanyDetail companyId={selectedId} />
        ) : (
          <div className="flex items-center justify-center h-full">
            <p style={{ color: 'var(--text-secondary)' }}>
              Select a company to view details
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
